import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OpenBillInfoModalComponent } from '../open-bill-info-modal/open-bill-info-modal.component';
import { MessageService } from 'src/app/services/message.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-order-card',
  templateUrl: './order-card.component.html',
  styleUrls: ['./order-card.component.scss'],
})
export class OrderCardComponent implements OnInit {
  @Input() o: any;
  @Output() refundRequest = new EventEmitter<any>();
  @Output() refundDetailRequest = new EventEmitter<any>();

  menu = false;

  constructor(
    private modal: MatDialog,
    private el: ElementRef,
    private message: MessageService,
    private router: Router,
  ) {}

  ngOnInit(): void {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.menu) return;

    const target = event.target as HTMLElement;
    const host = this.el.nativeElement as HTMLElement;

    if (!host.contains(target)) {
      this.menu = false;
      return;
    }

    if (!target.closest('.oc-more-btn') && !target.closest('.dropdown-menu')) {
      this.menu = false;
    }
  }

  openBill(data: any) {
    if (data.pay_price === 0) {
      this.message.open('纯钱包支付不能申请');
      return;
    }
    this.modal.open(OpenBillInfoModalComponent, {
      data: data,
      panelClass: 'app-dialog',
      width: '640px',
      maxWidth: '95vw',
    });
  }

  openTip() {
    this.message.open('开票申请已提交，预计7天内发送至邮箱');
  }

  openRefund() {
    this.menu = false;
    this.router.navigate(['/user/profile/orders/refund'], {
      queryParams: { id: this.o.id },
    });
  }

  /** 订单创建是否在 24 小时内 */
  get within24Hours(): boolean {
    let created: Date;
    const t = this.o?.created_time;
    if (!t) return false;
    if (typeof t === 'string') {
      created = new Date(t);
    } else if (typeof t === 'number') {
      created = new Date(t * 1000);
    } else if (t instanceof Date) {
      created = new Date(t);
    } else {
      return false;
    }
    if (isNaN(created.getTime())) return false;
    const now = Date.now();
    const diff = now - created.getTime();
    return diff >= 0 && diff < 24 * 60 * 60 * 1000;
  }

  /** 是否可申请退款：产品允许退款(优先级最高) + 已支付 + 已完成 + 24h 内 + 支付金额 > 0 + 没有提交过 */
  get canRefund(): boolean {
    return (
      this.o?.bus_type_snapshot?.allow_refund !== false &&
      (this.o?.status === 'Paid' || this.o?.status === 'Completed') &&
      this.within24Hours &&
      this.o.pay_price > 0 &&
      !this.o.refund_status
    );
  }

  openRefundDetail() {
    this.menu = false;
    this.router.navigate(['/user/profile/orders/refund'], {
      queryParams: { id: this.o.id, view: 'detail' },
    });
  }
}
